import {
  CraAttribute,
  CraAttributeName,
  CraAttributeType,
  getOptionTranslation,
} from "@keita/lanepatrol-sdk";
import { t } from "i18next";
import { attributeImageMap } from "./attribute-images";

export namespace CraAttributeUtils {
  export const getOptionLabel = (value: string) =>
    t(getOptionTranslation(value));

  export const getLabel = (attributeName: CraAttributeName) =>
    t(`sdk:attribute.label.${attributeName}`);

  export const getPlaceholder = (attributeName: CraAttributeName) =>
    t(`sdk:attribute.placeholder.${attributeName}`);

    export const getInfo = (attributeName: CraAttributeName) =>
    t(`sdk:attribute.info.${attributeName}`);

  export const getValueLabel = (
    attribute: CraAttribute,
    value: null | string | number,
  ): string => {
    if (value === null) return "-";
    if (value && attribute.type === CraAttributeType.Select) {
      return t(getOptionTranslation(value as string));
    }
    return `${value}`;
  };

  export const getImage = (
    definition: CraAttribute,
    value: string | number | null,
  ): string | undefined => {
    const maybeImage = attributeImageMap[definition.name];

    // attribute has no image
    if (!maybeImage) return maybeImage;

    // attribute has image
    if (typeof maybeImage === "string") return maybeImage;

    // attribute has value dependent image, but the value is null
    if (!value) return undefined;

    // attribute has value dependent image and value is not null
    return maybeImage[value as string];
  };
}
